import React from 'react';
import styled from "styled-components";
import {CaptionListProps} from "../../../types/caption";
import { useAtom,  } from 'jotai';
import { captionListState } from '../../../states/caption';

type CaptionButtonProps = {
  captionData : CaptionListProps
}

/**
 자막 추가/삭제 버튼

 * @param data1 설명
 * @return {data1} 반환
 * @throws ValidException 예외 발생
 * @author plaq99@rumpus.co.kr
 * @date 03-20-2023
 */


export default function CaptionButton({captionData}: CaptionButtonProps) {

  const DIALOG_FORMAT = "- \n- "
  const [captionList, setCaptionList] = useAtom(captionListState);

  const updatePeaksInstance = () => {         
      const peaksSegment = globalThis?.peaksInstance?.segments.getSegment(captionData.id!)
      if(peaksSegment) {
          const firstline = peaksSegment.labelText?.split('\n').at(0)
          peaksSegment.update({labelText : `${firstline}\n${DIALOG_FORMAT}`})
      }
  }
  

  const changeCaptionListToDialogFormat = () => {
      setCaptionList(prev => {
        return prev.map(v => {
          return v.id === captionData.id
                ? {...v, labelText : DIALOG_FORMAT, caption : DIALOG_FORMAT}
                : {...v}
        })
      })
  }

  const changeCaptionToDialogFormat = () => {
    changeCaptionListToDialogFormat()  
    updatePeaksInstance()
    // alert(1)
  }

  return (
    <BtnArea>
      <button
        type="button"
        className="btn btn_remove"
        title="자막 삭제"
        onClick={changeCaptionToDialogFormat}
      >
        <i className="bi bi-chat-left-text"></i>
        <span className="hide">대화자막추가</span>
      </button>

      {/*<button
        type="button"
        className="btn btn_remove"
        title="자막 삭제"
        onClick={() => {
        }}
      >
        <i className="bi bi-x-circle-fill"></i>
        <span className="hide">자막 삭제</span>
      </button>
      <button
        type="button"
        className="btn btn_add"
        title="자막 추가"
        onClick={() => {
        }}
      >
        <i className="bi bi-plus-circle-fill"></i>
        <span className="hide">자막 추가</span>
      </button>*/}
    </BtnArea>
  );
}

const BtnArea = styled.div`
  visibility: visible;
  display: flex;
  position: relative;
  width: 25px;
  align-items: end;

  .btn {
    font-size: 12px;
  }

  + .btn {
    margin-top: 5px;
  }
`;
